import domready from "domready";
import TouchTarget from "./modules/TouchTarget";

let menuButtons: NodeListOf<Element>;
let menu: HTMLElement;

const closeMenu = () => {
	menuButtons.forEach(x => x.classList.remove("on"));
	menu.classList.remove("visible");
};

domready(() => {
	menu = document.getElementById("mm");
	if (!menu)
		return;

	menuButtons = document.querySelectorAll(".menu-button");

	menuButtons.forEach((btn: HTMLElement) => {
		btn.addEventListener("click", () => {
			menuButtons.forEach(x => x.classList.toggle("on"));
			menu.classList.toggle("visible");
			btn.blur();
		});
	});

	const t = new TouchTarget(menu);
	t.onSwipe('right', closeMenu);

	menu.querySelectorAll(".nav-item .toggle").forEach((toggle: HTMLElement) => {
		toggle.addEventListener("click", e => {

			let parent = toggle.parentElement;
			while (parent !== document.documentElement) {
				if (parent.classList.contains("nav-item")) {
					parent.classList.toggle("expanded");
					break;
				}
				parent = parent.parentElement;
			}

			e.preventDefault();
			return false;
		});
	});

	//Stäng alla expanderade menyer
	menu.querySelectorAll(".expanded").forEach(x => x.classList.remove("expanded"));

	//Öppna menyerna ner till den aktiva sidan
	let item = menu.querySelector(".active");
	if (item)
		while(item !== menu && item !== document.documentElement) {
			if (item.classList.contains("nav-item"))
				item.classList.add("expanded");
			item = item.parentElement;
		}
})